export default {
	white: '#fff',
	black: 'black',
}
